/**
 * WebSocket 메시지 타입 가드 함수
 */

import type {
  WebSocketMessage,
  ProgressUpdate,
  TrackProgress,
  ErrorNotification,
  CompletionNotification,
  LogMessage,
  ControlResponse,
  CostUpdateMessage,
  StatsUpdateMessage,
  InitialDashboardMessage,
} from './types';

/** 진행률 업데이트 메시지인지 확인 */
export function isProgressUpdate(message: WebSocketMessage): message is ProgressUpdate {
  return message.type === 'progress_update';
}

/** 트랙 진행상황 메시지인지 확인 */
export function isTrackProgress(message: WebSocketMessage): message is TrackProgress {
  return message.type === 'track_progress';
}

/** 에러 알림 메시지인지 확인 */
export function isErrorNotification(message: WebSocketMessage): message is ErrorNotification {
  return message.type === 'error_notification';
}

/** 완료 알림 메시지인지 확인 */
export function isCompletionNotification(message: WebSocketMessage): message is CompletionNotification {
  return message.type === 'completion_notification';
}

/** 로그 메시지인지 확인 */
export function isLogMessage(message: WebSocketMessage): message is LogMessage {
  return message.type === 'log_message';
}

/** 제어 응답 메시지인지 확인 */
export function isControlResponse(message: WebSocketMessage): message is ControlResponse {
  return message.type === 'control_response';
}

/** 비용 업데이트 메시지인지 확인 */
export function isCostUpdate(message: WebSocketMessage): message is CostUpdateMessage {
  return message.type === 'cost_update';
}

/** 통계 업데이트 메시지인지 확인 */
export function isStatsUpdate(message: WebSocketMessage): message is StatsUpdateMessage {
  return message.type === 'stats_update';
}

/** 초기 대시보드 데이터 메시지인지 확인 */
export function isInitialDashboardData(message: WebSocketMessage): message is InitialDashboardMessage {
  return message.type === 'initial_dashboard_data';
}
